import React, { useEffect, useState } from 'react';

export type Options = {
  enabled?: boolean;
  onMouseLeave?: () => void;
  onMouseEnter?: () => void;
};

export const useMouseOutside = (
  elementRef: React.RefObject<HTMLElement>,
  { onMouseEnter, onMouseLeave, enabled }: Options = {},
) => {
  const [isOutside, setIsOutside] = useState(false);

  useEffect(() => {
    if (!enabled || !elementRef.current) {
      return;
    }

    const element = elementRef.current;

    const handleMouseLeave = () => {
      if (enabled && !isOutside) {
        onMouseLeave?.();
        setIsOutside(true);
      }
    };

    const handleMouseEnter = () => {
      setIsOutside(false);
      onMouseEnter?.();
    };

    // Add event listeners to the list container
    element.addEventListener('mouseleave', handleMouseLeave);
    element.addEventListener('mouseenter', handleMouseEnter);

    return () => {
      element.removeEventListener('mouseleave', handleMouseLeave);
      element.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [elementRef, enabled, isOutside, onMouseEnter, onMouseLeave]);

  return isOutside;
};
